import type { Audience, EditionStatus } from "./types/education.types.ts"

// Lists mirrored from ezbuild_back `apps/project_education`, pinned in full by
// `__tests__/education.contract.test.ts`.

/** `constants.FOCUS_CODES`. */
export const FOCUS_CODES: Record<Audience, readonly string[]> = {
  sales_person: [
    "objections",
    "discovery_questions",
    "materials",
    "budget_conversation",
    "timeline",
    "closing_next_step",
    "custom"
  ],
  customer: ["materials", "process", "preparing_home", "custom"]
}

export const CUSTOM_FOCUS_CODE = "custom"

/** `constants.READABLE_STATUSES`: an edition with real content to show. */
export const READABLE_EDITION_STATUSES: readonly EditionStatus[] = [
  "generated",
  "review_required",
  "published",
  "superseded"
]

/** `invitations.INTERNAL_READABLE_STATUSES`: narrower than the readable set,
 *  since a meeting invite never links a colleague to a superseded brief. */
export const INTERNAL_READABLE_STATUSES: readonly EditionStatus[] = [
  "generated",
  "review_required",
  "published"
]

/** `request_screening.SUGGESTIONS`: a rejected request suggests these display
 *  labels, not focus codes, so each one maps back to the code it stands for. */
export const REJECTION_SUGGESTION_CODES: Record<
  Audience,
  Record<string, string>
> = {
  sales_person: {
    Objections: "objections",
    "Discovery questions": "discovery_questions",
    Materials: "materials",
    "Budget conversation": "budget_conversation",
    Timeline: "timeline",
    "Closing / next step": "closing_next_step"
  },
  customer: {
    Materials: "materials",
    Process: "process",
    "Preparing your home": "preparing_home"
  }
}

/** Suggestions the backend sent, as focus codes this audience accepts, in the
 *  order they came; anything unknown is dropped rather than sent back as-is. */
export const suggestionFocusCodes = (
  audience: Audience,
  suggestions: string[]
): string[] =>
  suggestions
    .map((suggestion) => REJECTION_SUGGESTION_CODES[audience][suggestion])
    .filter(
      (code): code is string => !!code && FOCUS_CODES[audience].includes(code)
    )
